import { render, staticRenderFns } from "./TenseResult.vue?vue&type=template&id=223a467e&scoped=true"
import script from "./TenseResult.vue?vue&type=script&lang=js"
export * from "./TenseResult.vue?vue&type=script&lang=js"
import style0 from "./TenseResult.vue?vue&type=style&index=0&id=223a467e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a467e",
  null
  
)

export default component.exports